import InsightsPage from './insigthsPage';

export default InsightsPage;
